import React from 'react'

import { SVGArrowLeft } from '@common/public/assets'

import { BackButtonContainer, GoBackMessage } from './styles'

interface IBackButtonProperties {
    handleClick: () => void
    message: string
    hasCaret?: boolean
    isBackDisabled?: boolean
}

const BackButton: React.FC<IBackButtonProperties> = ({ handleClick, message, hasCaret, isBackDisabled = false }) => {
    return (
        <BackButtonContainer onClick={handleClick} disabled={isBackDisabled}>
            {hasCaret && <SVGArrowLeft />}
            <GoBackMessage>{message}</GoBackMessage>
        </BackButtonContainer>
    )
}

export default BackButton
